import React from 'react';
import { Link as LinkIcon, BoxIcon } from 'lucide-react';
interface AnnouncementCardProps {
  title: string;
  icon: BoxIcon;
  description?: string;
}
export function AnnouncementCard({
  title,
  icon: Icon,
  description
}: AnnouncementCardProps) {
  return <div className="flex items-center" data-id="element-2219">
      <div className="bg-purple-100 p-3 rounded-full mr-4" data-id="element-2220">
        <Icon size={24} className="text-purple-500" data-id="element-2221" />
      </div>
      <div className="flex-1" data-id="element-2222">
        <h4 className="font-medium" data-id="element-2223">{title}</h4>
        {description && <p className="text-gray-500 text-sm" data-id="element-2224">{description}</p>}
      </div>
      <div data-id="element-2225">
        <LinkIcon size={20} className="text-blue-500" data-id="element-2226" />
      </div>
    </div>;
}